// possible values for Button colors.
export enum ButtonColors {
  PRIMARY = 'primary', // button with gz blue color
  SECONDARY = 'secondary', // button with gray color
  NEGATIVE = 'negative', // button with gz error color
  WHITE = 'white', // button with white color
}

export type ButtonColor = ButtonColors.PRIMARY | ButtonColors.SECONDARY | ButtonColors.NEGATIVE | ButtonColors.WHITE;

// possible values for Button type
export enum ButtonTypes {
  FULL = 'full',
  QUIET = 'quiet', // just text color, no background color
  OUTLINE = 'outline', // transparent background and border color
  LINK = 'link',
}

export type ButtonType = ButtonTypes.FULL | ButtonTypes.QUIET | ButtonTypes.OUTLINE;

// possible values for Button themes.
export enum ButtonThemes {
  LIGHT = 'light', // button for light/white background
  DARK = 'dark', // button for dark/coloured background
}

export type ButtonTheme = ButtonThemes.LIGHT | ButtonThemes.DARK;

// possible values for Button font size
export enum ButtonFontSizes {
  SMALL = 'small', // 11px
  MEDIUM = 'medium', // 14px
}

export type ButtonFontSize = ButtonFontSizes.SMALL | ButtonFontSizes.MEDIUM;

export enum ButtonHeights {
  SMALL = 'small', // 24px
  MEDIUM = 'medium', // 32px
}

export type ButtonHeight = ButtonHeights.SMALL | ButtonHeights.MEDIUM;

export enum SplitButtonEvents {
  MAIN_BUTTON_CLICK = 'mainButtonClick',
}

export enum ButtonEvents {
  CLICK = 'click',
}

export enum GzButtonState {
  ENABLED = 'enabled',
  DISABLED = 'disabled',
  IS_LOADING = 'isLoading',
}
